import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  updateDoc, 
  deleteDoc,
  query,
  where,
  orderBy 
} from 'firebase/firestore';
import { db } from './config';

export const scheduleExceptionService = {
  // Crear una nueva excepción
  async createException(exceptionData) {
    try {
      const docRef = await addDoc(collection(db, 'schedule_exceptions'), {
        ...exceptionData,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      });
      
      console.log('Excepción creada con ID:', docRef.id);
      return docRef.id;
    } catch (error) {
      console.error('Error al crear excepción:', error);
      throw new Error('Error al crear la excepción de horario');
    }
  },

  // Obtener todas las excepciones
  async getAllExceptions() {
    try {
      const exceptionsRef = collection(db, 'schedule_exceptions');
      const q = query(exceptionsRef, orderBy('date', 'asc'));
      const querySnapshot = await getDocs(q);
      
      const exceptions = [];
      querySnapshot.forEach((doc) => {
        exceptions.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      console.log('Excepciones obtenidas:', exceptions.length);
      return exceptions;
    } catch (error) {
      console.error('Error al obtener excepciones:', error);
      throw new Error('Error al cargar las excepciones');
    }
  },

  // Obtener excepción para una fecha específica
  async getExceptionForDate(date) {
    try {
      const exceptionsRef = collection(db, 'schedule_exceptions');
      const q = query(exceptionsRef, where('date', '==', date));
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        return null;
      }
      
      const doc = querySnapshot.docs[0];
      return {
        id: doc.id,
        ...doc.data()
      };
    } catch (error) {
      console.error('Error al obtener excepción para fecha:', error);
      return null;
    }
  },

  // Actualizar una excepción existente
  async updateException(exceptionId, exceptionData) {
    try {
      const exceptionRef = doc(db, 'schedule_exceptions', exceptionId);
      await updateDoc(exceptionRef, {
        ...exceptionData,
        updatedAt: new Date().toISOString()
      });
      
      console.log('Excepción actualizada:', exceptionId);
      return true;
    } catch (error) {
      console.error('Error al actualizar excepción:', error);
      throw new Error('Error al actualizar la excepción');
    }
  },

  // Eliminar una excepción
  async deleteException(exceptionId) {
    try {
      const exceptionRef = doc(db, 'schedule_exceptions', exceptionId);
      await deleteDoc(exceptionRef);
      
      console.log('Excepción eliminada:', exceptionId);
      return true;
    } catch (error) {
      console.error('Error al eliminar excepción:', error);
      throw new Error('Error al eliminar la excepción');
    }
  },

  // Verificar si una fecha tiene excepciones activas
  async hasExceptionForDate(date) {
    try {
      const exception = await this.getExceptionForDate(date);
      return exception !== null;
    } catch (error) {
      console.error('Error al verificar excepción:', error);
      return false;
    }
  },

  // Obtener todas las excepciones futuras (desde hoy)
  async getFutureExceptions() {
    try {
      const today = new Date().toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      
      const exceptionsRef = collection(db, 'schedule_exceptions');
      const querySnapshot = await getDocs(exceptionsRef);
      
      const futureExceptions = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        // Comparar fechas (formato dd/mm/yyyy)
        const [day, month, year] = data.date.split('/');
        const [todayDay, todayMonth, todayYear] = today.split('/');
        
        const exceptionDate = new Date(year, month - 1, day);
        const todayDate = new Date(todayYear, todayMonth - 1, todayDay);
        
        if (exceptionDate >= todayDate) {
          futureExceptions.push({
            id: doc.id,
            ...data
          });
        }
      });
      
      // Ordenar por fecha
      futureExceptions.sort((a, b) => {
        const [dayA, monthA, yearA] = a.date.split('/');
        const [dayB, monthB, yearB] = b.date.split('/');
        
        const dateA = new Date(yearA, monthA - 1, dayA);
        const dateB = new Date(yearB, monthB - 1, dayB);
        
        return dateA - dateB;
      });
      
      return futureExceptions;
    } catch (error) {
      console.error('Error al obtener excepciones futuras:', error);
      return [];
    }
  },

  // Limpiar excepciones pasadas (función de mantenimiento)
  async cleanupPastExceptions() {
    try {
      const today = new Date().toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      
      const exceptionsRef = collection(db, 'schedule_exceptions');
      const querySnapshot = await getDocs(exceptionsRef);
      
      const deletePromises = [];
      querySnapshot.forEach((docSnapshot) => {
        const data = docSnapshot.data();
        const [day, month, year] = data.date.split('/');
        const [todayDay, todayMonth, todayYear] = today.split('/');
        
        const exceptionDate = new Date(year, month - 1, day);
        const todayDate = new Date(todayYear, todayMonth - 1, todayDay);
        
        // Si la fecha es anterior a hoy, marcar para eliminación
        if (exceptionDate < todayDate) {
          deletePromises.push(deleteDoc(docSnapshot.ref));
        }
      });
      
      await Promise.all(deletePromises);
      console.log(`Eliminadas ${deletePromises.length} excepciones pasadas`);
      
      return deletePromises.length;
    } catch (error) {
      console.error('Error al limpiar excepciones pasadas:', error);
      throw new Error('Error al limpiar excepciones pasadas');
    }
  }
};